import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faLocationDot, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faYoutubeSquare,
  faInstagramSquare,
  faRavelry,
  faPinterestSquare,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import { faUsers, faMailBulk, faNoteSticky } from '@fortawesome/free-solid-svg-icons';
import { Box, Typography, Link } from '@mui/material';

export default function Links({ links, vertical, iconColor }) {
  const styles = {
    icon: {
      color: iconColor || '#147EB3',
      width: 18,
      height: 18
    }
  };

  function getIcon(type) {
    switch (type) {
      case 'youtube':
        return faYoutubeSquare;
      case 'instagram':
        return faInstagramSquare;
      case 'facebook':
        return faFacebook;
      case 'ravelry':
        return faRavelry;
      case 'pinterest':
        return faPinterestSquare;
      case 'linkedin':
        return faLinkedin;
      case 'location':
        return faLocationDot;
      case 'tutorial':
        return faGraduationCap;
      case 'mightynetworks':
        return faUsers;
      case 'mailinglist':
        return faMailBulk;
      case 'website':
        return faGlobe;
      default:
        return faNoteSticky;
    }
  }

  return (
    links && (
      <Box
        sx={{
          display: 'flex',
          flexDirection: vertical ? 'column' : 'row',
          flexWrap: 'wrap',
          gap: 0.5,
          p: 1
        }}
      >
        {links.map((link, i) => {
          return link.url ? (
            <Box
              key={i}
              sx={{
                alignItems: 'center',
                display: 'flex',
                gap: 0.5,
                m: 0.5
              }}
            >
              <FontAwesomeIcon style={styles.icon} icon={getIcon(link.type)} />
              <Link href={link.url} target="_blank" rel="noreferrer" underline="hover">
                <Typography variant="body2">{link.name ? link.name : link.url}</Typography>
              </Link>
              {link.description && (
                <Typography variant="body2" color="text.secondary">
                  {link.description}
                </Typography>
              )}
            </Box>
          ) : (
            <Box key={i} sx={{ alignItems: 'center', display: 'flex', gap: 0.5, m: 0.5 }}>
              <FontAwesomeIcon style={styles.icon} icon={getIcon(link.type)} />
              {link.name && <Typography variant="body2">{link.name}</Typography>}
              {link.description && (
                <Typography variant="body2" color="text.secondary">
                  {link.description}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    )
  );
}
